module.exports = __webpack_public_path__ + "img/img83.46fbf1a2.svg";